import { useParams } from "react-router";
import {
  MilestonePage,
  MilestonePageContent,
} from "@/shared/service-manager/default-ui/milestone-page/milestone-page";
import { CountingsTable } from "./countings-table";

export function CountingsIndexRoute() {
  const { processId } = useParams();

  return (
    <MilestonePage>
      <MilestonePageContent>
        <CountingsTable processId={processId!} />
      </MilestonePageContent>
    </MilestonePage>
  );
}
